<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      <div class="row">
        <div class="col-12">
          <img class="document-img" :src="docUrl" alt>
        </div>
      </div>
      
      <footer>
        <popup-bottom-container>
          <template slot="end">
            <div class="section-new-doc"> 
              <img
                class="cross-circle-img"
                src="@/assets/download.svg"
                alt
              /> 
              <a :href="docUrl" style="text-decoration: none;"><span class="add-new-document">Download Document</span></a>
            </div>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: "fullFormsPopup",
  props: {
    docUrl: {
      type: String,
    },
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      showUnAssignModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.cross-circle-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.document-img {
  width: 100%;
  text-align: center;
}

.section-new-doc {
  cursor: pointer;
  display: inherit;
}

.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}


</style>
